import { Link, useLocation } from "react-router-dom";
import { Phone, Calculator } from "@phosphor-icons/react";

export default function MobileCTA() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/book") || pathname.startsWith("/admin")) return null;
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-xl border-t border-[#E4E4E7] px-3 py-2.5 grid grid-cols-2 gap-2"
      style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }} data-testid="mobile-cta-bar">
      <a href="tel:+16199993565" data-testid="mobile-cta-call"
        className="flex items-center justify-center gap-2 bg-[#15306E] text-white font-display font-bold text-sm py-3 rounded-sm active:scale-[0.98] transition-transform">
        <Phone size={18} weight="fill" /> Call / Text
      </a>
      <Link to="/junk-removal-cost" data-testid="mobile-cta-price"
        className="flex items-center justify-center gap-2 bg-[#46A01E] text-white font-display font-bold text-sm py-3 rounded-sm active:scale-[0.98] transition-transform">
        <Calculator size={18} weight="fill" /> Get My Price
      </Link>
    </div>
  );
}
